import { AppStatusBarContextProps } from '@psl/appComponents/statusBar/types';
import { useCreation } from '@psl/functions/hooks/useCreation';
import { StatusBarStyle } from 'expo-status-bar';
import { memo, ReactNode, useMemo } from 'react';
import { BehaviorSubject } from 'rxjs';
import { AppStatusBarContext } from './context';

export const AppStatusBarContextProvider = memo(
  ({ name, children }: { name: string; children?: ReactNode }) => {
    const barStyles$ = useCreation(
      () => new BehaviorSubject<StatusBarStyle[]>(['auto']),
      [],
    );

    const value = useMemo<AppStatusBarContextProps>(
      () => ({ name, barStyles$ }),
      [name, barStyles$],
    );

    return (
      <AppStatusBarContext.Provider value={value}>
        {children}
      </AppStatusBarContext.Provider>
    );
  },
);

export const useStatusBarStyle = () => {};
